import '@/assets/scss/style.scss';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import 'mapbox-gl/dist/mapbox-gl.css';

import('@/common/infrastructure/config/sentry');

import App from '@/common/presentation/App';
import SnackbarProvider from '@/common/presentation/SnackbarProvider';
import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LicenseInfo } from '@mui/x-license';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import apolloClient from './common/infrastructure/gql/apollo/client';
import reportWebVitals from './common/infrastructure/services/reportWebVitals';
import { themeOptions } from './common/presentation/themeOptions';

(async () => {
  LicenseInfo.setLicenseKey(import.meta.env.VITE_MUIX_LICENSE_KEY);

  const LDProvider = await asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCHDARKLY_ENV,
    // TODO: replace fake user data with real user data once we get it from authentication token
    context: {
      kind: 'user',
      key: 'user-temp-raptor',
      name: 'John Doe',
      email: 'raptor@rapidworks.com',
    },
    options: {
      /* ... */
    },
    timeout: 5,
  });

  const container = document.getElementById('root');
  const root = createRoot(container!);

  root.render(
    <LDProvider>
      <ApolloProvider client={apolloClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider theme={themeOptions}>
            <CssBaseline />
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </ApolloProvider>
    </LDProvider>,
  );

  reportWebVitals();
})();

// Export components for use in other files
export { App, reportWebVitals };
